<div class="screen-element day-planner-screen">
	<div class="headline1">{{title|uppercase}}</div>
	<div class="headline2">{{subtitle}}</div>
	<div class="dashboard-center">
		
		<div *ngIf="conflict" class="value smaller">{{translator.tr("TIMEWINDOWS_EDITOR_INTERFACE")}}</div>
		<div *ngIf="!conflict" class="value">{{getCurrentTime()| date:"HH:mm"}}</div>
		<div class="unit"></div>
	</div>

	<div class="bar">
		<div class="bar-wrap" [ngStyle]="{left:left}">
			<div class="scale">
				
					<div class="hour" *ngFor="let hour of hours">
						<span class="caption" *ngIf="hour % 3 == 0">{{hour}}</span>
					
						<div *ngIf="hour < 24" class="block" [ngStyle]="{background:getBackground(hour,10)}"></div>
						<div *ngIf="hour < 24" class="block" [ngStyle]="{background:getBackground(hour,20)}"></div>
						<div *ngIf="hour < 24" class="block" [ngStyle]="{background:getBackground(hour,30)}"></div>
						<div *ngIf="hour < 24" class="block" [ngStyle]="{background:getBackground(hour,40)}"></div>
						<div *ngIf="hour < 24" class="block" [ngStyle]="{background:getBackground(hour,50)}"></div>
						<div *ngIf="hour < 24" class="block" [ngStyle]="{background:getBackground(hour,55)}"></div>
					
					</div>
				
			</div>
		</div>
	</div>
	<div *ngIf="stage == 'start_time'" class="rangeLimit rangeLimitMin"></div>
	<div *ngIf="stage == 'end_time'" class="rangeLimit rangeLimitMax"></div>
</div>
